import PropTypes from 'prop-types';
import { css, cx } from '@eti/styles';
import Icon from '../icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = css`
  align-items: center;
  display: flex;
  height: inherit;
  justify-content: center;
  position: absolute;
  width: inherit;
`;
const iconStyles = css`
  position: relative;
`;
const StackedIcon = _ref => {
  let {
    className,
    icons,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ...rest,
    className: cx('etiStackedIcon', iconStyles, className),
    children: icons.map((icon, index) => /*#__PURE__*/_jsx("div", {
      className: cx('etiIcon__wrapper', wrapperStyles),
      children: typeof icon === 'string' ? /*#__PURE__*/_jsx(Icon, {
        className: `etiStackedIcon__icon etiStackedIcon__icon--${index}`,
        id: icon
      }) : /*#__PURE__*/_jsx(Icon, {
        className: icon.className,
        color: icon.color,
        height: icon.height,
        id: icon.id,
        size: icon.size,
        top: icon.top,
        width: icon.width
      })
    }, typeof icon === 'string' ? icon : icon.id))
  });
};
StackedIcon.propTypes = {
  className: PropTypes.string,
  icons: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    color: PropTypes.string,
    height: PropTypes.string,
    id: PropTypes.string.isRequired,
    size: PropTypes.string,
    top: PropTypes.string,
    width: PropTypes.string
  }))]).isRequired
};
export default StackedIcon;
//# sourceMappingURL=StackedIcon.js.map